// @ts-expect-error
import { Lightbox } from 'react-modal-image';
import React, { Fragment, useState } from 'react';
import ReactPlaceholder from 'react-placeholder';

type Props = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
    shouldScroll?: boolean;
    allowLightbox?: boolean;
};

export function ImageWrapper(props: Props) {
    const [loaded, setLoaded] = useState(false);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [dragging, setDragging] = useState(false);

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        if (!dragging) {
            if (props.onClick) {
                // @ts-expect-error
                props.onClick();
            } else {
                openLightbox();
            }
        }
        setDragging(false);
    };

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!dragging) {
            if (props.onClick) {
                // @ts-expect-error
                props.onClick();
            } else {
                openLightbox();
            }
        }
        setDragging(false);
    };

    const handleImageLoaded = () => {
        setLoaded(true);
        const { shouldScroll } = props;
        if (shouldScroll) {
            window.scrollTo(0, 0);
        }
    };

    const openLightbox = () => {
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };

    const imageStyle = !loaded ? { ...props.style, display: 'none' } : { ...props.style };
    const imageProps = {
        ...props,
    };
    delete imageProps.shouldScroll;
    delete imageProps.allowLightbox;
    delete imageProps.style;
    delete imageProps.onClick;

    const image = (
        <img
            alt=""
            {...imageProps}
            style={imageStyle}
            onLoad={handleImageLoaded}
            onTouchStart={() => {
                setDragging(false);
            }}
            onTouchMove={() => {
                setDragging(true);
            }}
            onTouchEnd={handleTouch}
            onClick={handleClick}
        />
    );

    // const Placeholder = () => {
    //     return <ReactLoading type="spin" color="#768285" height={30} width={30} />
    // }

    return (
        <Fragment>
            <ReactPlaceholder
                type="rect"
                ready={loaded}
                style={{ height: 30 }}
                // customPlaceholder={Placeholder}
            >
                <div className="image-holder">{image}</div>
            </ReactPlaceholder>
            {!loaded && image}
            {props.allowLightbox && lightboxOpen && (
                <Lightbox large={imageProps.src} onClose={closeLightbox} hideZoom={true} hideDownload={true} />
            )}
        </Fragment>
    );
}
